import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import {
    ITCIMarketplaceConnectorRequest,
    ITCIMarketplaceConnectorResponse,
    ITCIMarketplaceConnector,
    TCIMarketplaceSupportedTechs
} from "@tci/common";
import { BaseMarketplaceProvider } from "../tci-tenant-services";

@Injectable()
export class TciTenantBaseMarketplaceSharedService extends BaseMarketplaceProvider {
    getConnectors(): Observable<ITCIMarketplaceConnector[]> {
        return Observable.of([]);
    }

    getConnectorById(input: ITCIMarketplaceConnectorRequest): Observable<ITCIMarketplaceConnector> {
        return Observable.of(null);
    }


    canInstallConnector(input: ITCIMarketplaceConnectorRequest): Observable<boolean> {
        return Observable.of(!input.connector.details.installed);
    }

    canUninstallConnector(input: ITCIMarketplaceConnectorRequest): Observable<boolean> {
        return Observable.of(input.connector.details.installed && input.connector.details.uninstallable);
    }

    installConnector(input: ITCIMarketplaceConnectorRequest): Observable<ITCIMarketplaceConnectorResponse> {
        return Observable.of(null);
    }

    uninstallConnector(input: ITCIMarketplaceConnectorRequest): Observable<ITCIMarketplaceConnectorResponse> {
        return Observable.of(null);
    }

    isConnectorEnabled(input: ITCIMarketplaceConnectorRequest): Observable<boolean> {
        return Observable.of(input.connector.details.isFree);
    }

    getSuportedTechs(input: ITCIMarketplaceConnectorRequest): Observable<TCIMarketplaceSupportedTechs[]> {
        const techs: TCIMarketplaceSupportedTechs[] = [];

        if (input.connector.details.supportCloudAgents) {
            techs.push(TCIMarketplaceSupportedTechs.cloudAgents);
        }

        if (input.connector.details.isISSource) {
            techs.push(TCIMarketplaceSupportedTechs.integration);
        }

        if (input.connector.details.isMSSource) {
            techs.push(TCIMarketplaceSupportedTechs.migration);
        }

        if (input.connector.details.isRSSource) {
            techs.push(TCIMarketplaceSupportedTechs.replication);
        }

        return Observable.of(techs);
    }
}
